import AccountReceivableListModal from '@/components/_common/AccountReceivableListModal';
import { AccountReceivableSituation } from '@/core/domain/financial/AccountReceivable/AccountReceivable.types';
import { useDisclosure } from '@/hooks';
import { DateTimeFormat } from '@/utils/moment';
import moment from 'moment';
import React from 'react';

import {
  StatisticDashboardModule,
  StatisticDashboardTypeColor,
} from '@/components/_common/StatisticDashboard';
import DashboardStatisticCard from '../../DashboardStatisticCard';

interface Props {
  value?: number;
}

const ReceivablePayDayQuantity: React.FC<Props> = ({ value }) => {
  const [viewAccountReceivablesOpen, viewAccountReceivablesActions] =
    useDisclosure();

  return (
    <>
      <DashboardStatisticCard
        tooltipTitle="Quantidade de parcelas recebidas hoje."
        statisticTitle="Recebidas | Qtde."
        color={StatisticDashboardTypeColor.income}
        value={value}
        module={StatisticDashboardModule.accountReceivable}
        onClick={viewAccountReceivablesActions.open}
      />

      <AccountReceivableListModal
        open={viewAccountReceivablesOpen}
        onCancel={viewAccountReceivablesActions.close}
        queryFilter={{
          situation: AccountReceivableSituation.settled,
          payDate: moment().format(DateTimeFormat),
        }}
      />
    </>
  );
};

export default ReceivablePayDayQuantity;
